/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PublicHotelkonzeptDocumentType {
    Affinity = 'Affinity',
    Betriebshaftpflicht = 'Betriebshaftpflicht',
    Betriebsunterbrechung = 'Betriebsunterbrechung',
    Cyber = 'Cyber',
    DAndO = 'DAndO',
    EcDeckungUnbekanteGefahren = 'EcDeckungUnbekanteGefahren',
    EinbruchDiebstahl = 'EinbruchDiebstahl',
    Elektronik = 'Elektronik',
    Feuer = 'Feuer',
    Folder = 'Folder',
    Garantieverlaengerung = 'Garantieverlaengerung',
    Geraeteversicherung = 'Geraeteversicherung',
    Glas = 'Glas',
    Gruppenkrankenversicherung = 'Gruppenkrankenversicherung',
    Haftpflicht = 'Haftpflicht',
    KfzVersicherung = 'KfzVersicherung',
    KollektivUnfall = 'KollektivUnfall',
    Krankenzusatzversicherung = 'Krankenzusatzversicherung',
    Kuehlgut = 'Kuehlgut',
    Leitungswasser = 'Leitungswasser',
    Maschinenbruch = 'Maschinenbruch',
    Rechtsschutz = 'Rechtsschutz',
    Reiseversicherung = 'Reiseversicherung',
    SeuchenBu = 'SeuchenBu',
    Sturm = 'Sturm',
    Versicherungsbausteine = 'Versicherungsbausteine'
  }

    export const PublicHotelkonzeptDocumentTypeTranslocoMap: Record<PublicHotelkonzeptDocumentType, string> = {
    [PublicHotelkonzeptDocumentType.Affinity]: 'publicHotelkonzeptDocumentType.affinity',
    [PublicHotelkonzeptDocumentType.Betriebshaftpflicht]: 'publicHotelkonzeptDocumentType.betriebshaftpflicht',
    [PublicHotelkonzeptDocumentType.Betriebsunterbrechung]: 'publicHotelkonzeptDocumentType.betriebsunterbrechung',
    [PublicHotelkonzeptDocumentType.Cyber]: 'publicHotelkonzeptDocumentType.cyber',
    [PublicHotelkonzeptDocumentType.DAndO]: 'publicHotelkonzeptDocumentType.dAndO',
    [PublicHotelkonzeptDocumentType.EcDeckungUnbekanteGefahren]: 'publicHotelkonzeptDocumentType.ecDeckungUnbekanteGefahren',
    [PublicHotelkonzeptDocumentType.EinbruchDiebstahl]: 'publicHotelkonzeptDocumentType.einbruchDiebstahl',
    [PublicHotelkonzeptDocumentType.Elektronik]: 'publicHotelkonzeptDocumentType.elektronik',
    [PublicHotelkonzeptDocumentType.Feuer]: 'publicHotelkonzeptDocumentType.feuer',
    [PublicHotelkonzeptDocumentType.Folder]: 'publicHotelkonzeptDocumentType.folder',
    [PublicHotelkonzeptDocumentType.Garantieverlaengerung]: 'publicHotelkonzeptDocumentType.garantieverlaengerung',
    [PublicHotelkonzeptDocumentType.Geraeteversicherung]: 'publicHotelkonzeptDocumentType.geraeteversicherung',
    [PublicHotelkonzeptDocumentType.Glas]: 'publicHotelkonzeptDocumentType.glas',
    [PublicHotelkonzeptDocumentType.Gruppenkrankenversicherung]: 'publicHotelkonzeptDocumentType.gruppenkrankenversicherung',
    [PublicHotelkonzeptDocumentType.Haftpflicht]: 'publicHotelkonzeptDocumentType.haftpflicht',
    [PublicHotelkonzeptDocumentType.KfzVersicherung]: 'publicHotelkonzeptDocumentType.kfzVersicherung',
    [PublicHotelkonzeptDocumentType.KollektivUnfall]: 'publicHotelkonzeptDocumentType.kollektivUnfall',
    [PublicHotelkonzeptDocumentType.Krankenzusatzversicherung]: 'publicHotelkonzeptDocumentType.krankenzusatzversicherung',
    [PublicHotelkonzeptDocumentType.Kuehlgut]: 'publicHotelkonzeptDocumentType.kuehlgut',
    [PublicHotelkonzeptDocumentType.Leitungswasser]: 'publicHotelkonzeptDocumentType.leitungswasser',
    [PublicHotelkonzeptDocumentType.Maschinenbruch]: 'publicHotelkonzeptDocumentType.maschinenbruch',
    [PublicHotelkonzeptDocumentType.Rechtsschutz]: 'publicHotelkonzeptDocumentType.rechtsschutz',
    [PublicHotelkonzeptDocumentType.Reiseversicherung]: 'publicHotelkonzeptDocumentType.reiseversicherung',
    [PublicHotelkonzeptDocumentType.SeuchenBu]: 'publicHotelkonzeptDocumentType.seuchenBu',
    [PublicHotelkonzeptDocumentType.Sturm]: 'publicHotelkonzeptDocumentType.sturm',
    [PublicHotelkonzeptDocumentType.Versicherungsbausteine]: 'publicHotelkonzeptDocumentType.versicherungsbausteine',
    };

    export const PublicHotelkonzeptDocumentTypeOptions = [
  { value: PublicHotelkonzeptDocumentType.Affinity, labelKey: 'publicHotelkonzeptDocumentType.affinity' },
  { value: PublicHotelkonzeptDocumentType.Betriebshaftpflicht, labelKey: 'publicHotelkonzeptDocumentType.betriebshaftpflicht' },
  { value: PublicHotelkonzeptDocumentType.Betriebsunterbrechung, labelKey: 'publicHotelkonzeptDocumentType.betriebsunterbrechung' },
  { value: PublicHotelkonzeptDocumentType.Cyber, labelKey: 'publicHotelkonzeptDocumentType.cyber' },
  { value: PublicHotelkonzeptDocumentType.DAndO, labelKey: 'publicHotelkonzeptDocumentType.dAndO' },
  { value: PublicHotelkonzeptDocumentType.EcDeckungUnbekanteGefahren, labelKey: 'publicHotelkonzeptDocumentType.ecDeckungUnbekanteGefahren' },
  { value: PublicHotelkonzeptDocumentType.EinbruchDiebstahl, labelKey: 'publicHotelkonzeptDocumentType.einbruchDiebstahl' },
  { value: PublicHotelkonzeptDocumentType.Elektronik, labelKey: 'publicHotelkonzeptDocumentType.elektronik' },
  { value: PublicHotelkonzeptDocumentType.Feuer, labelKey: 'publicHotelkonzeptDocumentType.feuer' },
  { value: PublicHotelkonzeptDocumentType.Folder, labelKey: 'publicHotelkonzeptDocumentType.folder' },
  { value: PublicHotelkonzeptDocumentType.Garantieverlaengerung, labelKey: 'publicHotelkonzeptDocumentType.garantieverlaengerung' },
  { value: PublicHotelkonzeptDocumentType.Geraeteversicherung, labelKey: 'publicHotelkonzeptDocumentType.geraeteversicherung' },
  { value: PublicHotelkonzeptDocumentType.Glas, labelKey: 'publicHotelkonzeptDocumentType.glas' },
  { value: PublicHotelkonzeptDocumentType.Gruppenkrankenversicherung, labelKey: 'publicHotelkonzeptDocumentType.gruppenkrankenversicherung' },
  { value: PublicHotelkonzeptDocumentType.Haftpflicht, labelKey: 'publicHotelkonzeptDocumentType.haftpflicht' },
  { value: PublicHotelkonzeptDocumentType.KfzVersicherung, labelKey: 'publicHotelkonzeptDocumentType.kfzVersicherung' },
  { value: PublicHotelkonzeptDocumentType.KollektivUnfall, labelKey: 'publicHotelkonzeptDocumentType.kollektivUnfall' },
  { value: PublicHotelkonzeptDocumentType.Krankenzusatzversicherung, labelKey: 'publicHotelkonzeptDocumentType.krankenzusatzversicherung' },
  { value: PublicHotelkonzeptDocumentType.Kuehlgut, labelKey: 'publicHotelkonzeptDocumentType.kuehlgut' },
  { value: PublicHotelkonzeptDocumentType.Leitungswasser, labelKey: 'publicHotelkonzeptDocumentType.leitungswasser' },
  { value: PublicHotelkonzeptDocumentType.Maschinenbruch, labelKey: 'publicHotelkonzeptDocumentType.maschinenbruch' },
  { value: PublicHotelkonzeptDocumentType.Rechtsschutz, labelKey: 'publicHotelkonzeptDocumentType.rechtsschutz' },
  { value: PublicHotelkonzeptDocumentType.Reiseversicherung, labelKey: 'publicHotelkonzeptDocumentType.reiseversicherung' },
  { value: PublicHotelkonzeptDocumentType.SeuchenBu, labelKey: 'publicHotelkonzeptDocumentType.seuchenBu' },
  { value: PublicHotelkonzeptDocumentType.Sturm, labelKey: 'publicHotelkonzeptDocumentType.sturm' },
  { value: PublicHotelkonzeptDocumentType.Versicherungsbausteine, labelKey: 'publicHotelkonzeptDocumentType.versicherungsbausteine' },
    ];

